import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
export function Contact() {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    phone: '',
    service: '',
    date: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle form submission logic here
    console.log('Form submitted:', formState);
    alert('Thank you for your booking request. We will contact you shortly to confirm.');
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value
    });
  };
  return <section id="contact" className="py-24 bg-[#0A0A0A]" data-id="element-37">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-38">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16" data-id="element-39">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} data-id="element-40">
            <h2 className="text-4xl md:text-5xl text-[#F5F0EB] mb-6" data-id="element-41">
              Visit Our Sanctuary
            </h2>
            <div className="h-1 bg-[#D4AF37] w-20 mb-8" data-id="element-42" />
            <p className="text-lg text-[#999999] mb-10 leading-relaxed" data-id="element-43">
              Ready to experience ultimate relaxation? Book your session today
              or reach out with any questions. We look forward to welcoming you.
            </p>

            <div className="space-y-8" data-id="element-44">
              <div className="flex items-start" data-id="element-45">
                <MapPin className="w-6 h-6 text-[#D4AF37] mr-4 mt-1 flex-shrink-0" data-id="element-46" />
                <div data-id="element-47">
                  <h4 className="text-[#F5F0EB] font-semibold mb-1" data-id="element-48">
                    Location
                  </h4>
                  <p className="text-[#999999]" data-id="element-49">
                    123 Tranquility Lane
                    <br data-id="element-50" />
                    Wellness District, CA 90210
                  </p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-51">
                <Phone className="w-6 h-6 text-[#D4AF37] mr-4 mt-1 flex-shrink-0" data-id="element-52" />
                <div data-id="element-53">
                  <h4 className="text-[#F5F0EB] font-semibold mb-1" data-id="element-54">Phone</h4>
                  <p className="text-[#999999]" data-id="element-55">(555) 123-4567</p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-56">
                <Mail className="w-6 h-6 text-[#D4AF37] mr-4 mt-1 flex-shrink-0" data-id="element-57" />
                <div data-id="element-58">
                  <h4 className="text-[#F5F0EB] font-semibold mb-1" data-id="element-59">Email</h4>
                  <p className="text-[#999999]" data-id="element-60">hello@serenityspa.com</p>
                </div>
              </div>

              <div className="flex items-start" data-id="element-61">
                <Clock className="w-6 h-6 text-[#D4AF37] mr-4 mt-1 flex-shrink-0" data-id="element-62" />
                <div data-id="element-63">
                  <h4 className="text-[#F5F0EB] font-semibold mb-1" data-id="element-64">Hours</h4>
                  <p className="text-[#999999]" data-id="element-65">
                    Mon - Fri: 9:00 AM - 8:00 PM
                    <br data-id="element-66" />
                    Sat - Sun: 10:00 AM - 6:00 PM
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="bg-[#1A1A1A] p-8 md:p-10 rounded-sm shadow-sm border border-[#2A2A2A]" data-id="element-67">
            <h3 className="text-3xl text-[#F5F0EB] mb-6" data-id="element-68">Request a Booking</h3>
            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-69">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-70">
                <div data-id="element-71">
                  <label htmlFor="name" className="block text-sm font-medium text-[#999999] mb-2" data-id="element-72">
                    Full Name
                  </label>
                  <input type="text" id="name" name="name" required value={formState.name} onChange={handleChange} className="w-full px-4 py-3 bg-[#111111] border border-[#2A2A2A] text-[#F5F0EB] rounded-sm focus:outline-none focus:ring-2 focus:ring-[#D4AF37] focus:border-transparent transition-shadow" data-id="element-73" />
                </div>
                <div data-id="element-74">
                  <label htmlFor="phone" className="block text-sm font-medium text-[#999999] mb-2" data-id="element-75">
                    Phone Number
                  </label>
                  <input type="tel" id="phone" name="phone" required value={formState.phone} onChange={handleChange} className="w-full px-4 py-3 bg-[#111111] border border-[#2A2A2A] text-[#F5F0EB] rounded-sm focus:outline-none focus:ring-2 focus:ring-[#D4AF37] focus:border-transparent transition-shadow" data-id="element-76" />
                </div>
              </div>

              <div data-id="element-77">
                <label htmlFor="email" className="block text-sm font-medium text-[#999999] mb-2" data-id="element-78">
                  Email Address
                </label>
                <input type="email" id="email" name="email" required value={formState.email} onChange={handleChange} className="w-full px-4 py-3 bg-[#111111] border border-[#2A2A2A] text-[#F5F0EB] rounded-sm focus:outline-none focus:ring-2 focus:ring-[#D4AF37] focus:border-transparent transition-shadow" data-id="element-79" />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-80">
                <div data-id="element-81">
                  <label htmlFor="service" className="block text-sm font-medium text-[#999999] mb-2" data-id="element-82">
                    Service
                  </label>
                  <select id="service" name="service" required value={formState.service} onChange={handleChange} className="w-full px-4 py-3 bg-[#111111] border border-[#2A2A2A] text-[#F5F0EB] rounded-sm focus:outline-none focus:ring-2 focus:ring-[#D4AF37] focus:border-transparent transition-shadow" data-id="element-83">
                    <option value="" data-id="element-84">Select a service</option>
                    <option value="swedish" data-id="element-85">Swedish Massage</option>
                    <option value="deep-tissue" data-id="element-86">Deep Tissue</option>
                    <option value="hot-stone" data-id="element-87">Hot Stone</option>
                    <option value="aromatherapy" data-id="element-88">Aromatherapy</option>
                    <option value="sports" data-id="element-89">Sports Massage</option>
                    <option value="prenatal" data-id="element-90">Prenatal Massage</option>
                  </select>
                </div>
                <div data-id="element-91">
                  <label htmlFor="date" className="block text-sm font-medium text-[#999999] mb-2" data-id="element-92">
                    Preferred Date
                  </label>
                  <input type="date" id="date" name="date" required value={formState.date} onChange={handleChange} className="w-full px-4 py-3 bg-[#111111] border border-[#2A2A2A] text-[#F5F0EB] rounded-sm focus:outline-none focus:ring-2 focus:ring-[#D4AF37] focus:border-transparent transition-shadow" data-id="element-93" />
                </div>
              </div>

              <div data-id="element-94">
                <label htmlFor="message" className="block text-sm font-medium text-[#999999] mb-2" data-id="element-95">
                  Special Requests / Notes
                </label>
                <textarea id="message" name="message" rows={4} value={formState.message} onChange={handleChange} className="w-full px-4 py-3 bg-[#111111] border border-[#2A2A2A] text-[#F5F0EB] rounded-sm focus:outline-none focus:ring-2 focus:ring-[#D4AF37] focus:border-transparent transition-shadow resize-none" data-id="element-96"></textarea>
              </div>

              <button type="submit" className="w-full bg-[#D4AF37] text-[#0A0A0A] py-4 rounded-sm hover:bg-[#F0D060] transition-colors duration-300 font-medium uppercase tracking-wider text-sm shadow-sm" data-id="element-97">
                Submit Request
              </button>
            </form>
          </motion.div>
        </div>
      </div>
    </section>;
}